export default "/assets/8b093fe513af0e04.png"